var printTemplate = `<html>
	<head>
		<meta charset="utf-8">
		<title>Booking Confirmation</title>
		<link rel="stylesheet" href="/print-temp.css">
		<link rel="license" href="https://www.opensource.org/licenses/mit-license/">
		<script src="script.js"></script>
	</head>
	<body>
		<header>
			<h1>Booking Confirmation</h1>
			<address >
				<p>Madinaty Sporting Club</p>
				<p>B3 Madinaty<br>New Cairo</p>
			</address>
			<span><img width="60px" alt="" src="https://madinatysportingclub.com/logoR.png"></span>
		</header>
		<article>
			<h1>Recipient</h1>
			<address >
				<p>{{fullName}}</p>
			</address>
			<table class="meta">
				<tr>
					<th><span >Membership #</span></th>
					<td><span >{{membershipId}}</td>
          <tr>
				<tr>
					<th><span >Date</span></th>
					<td><span >{{date}}</td>
          <tr>
					<th><span >Time</span></th>
					<td><span >{{time}}</td>
				</tr>
				
			</table>
			<table class="inventory">
		<!-- 		<thead>
					<tr>
						<th><span >Item</span></th>
						<th><span >Description</span></th>
						<th><span >Rate</span></th>
						<th><span >Quantity</span></th>
						<th><span >Price</span></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td><a class="cut">-</a><span >Front End Consultation</span></td>
						<td><span >Experience Review</span></td>
						<td><span data-prefix>$</span><span >150.00</span></td>
						<td><span >4</span></td>
						<td><span data-prefix>$</span><span>600.00</span></td>
					</tr>
				</tbody> -->
			</table>
<!-- 			<a class="add">+</a> -->
        </br>
			<table class="balance">
				<tr>
					<th><span >Email</span></th>
					<td><span data-prefix>{{email}}</span></td>
				</tr>
				<tr>
					<th><span >Phone Number</span</th>
					<td><span data-prefix>{{phoneNumber}}</span</td>
				</tr>
				<tr>
					<th><span >National ID / Passport ID
</span></th>
					<td><span data-prefix>{{nationalId}}</span</td>
				</tr>
        <tr>
					<th><span >Membership ID</span></th>
					<td><span data-prefix>{{membershipId}}</td>
				</tr>
        <tr>
					<th><span >Number of members</span></th>
					<td><span data-prefix>{{numberOfMembers}}</td>
				</tr>
			</table>
		</article>
		<aside>
			<h1><span >Additional Notes</span></h1>
			<div class="additinal" dir="rtl">
				<p>يرجى ملاحظة أنه سيتم تسليم الكارنيهات للأشخاص المذكورين فقط، وهم العضو العامل، الزوج أو الزوجة، أو وكيل مفوض بتوكيل رسمي عام.
لن يتم تسليم الكارنيهات لأي شخص آخر. نرجو منك التأكد من إحضار الوثائق اللازمة لإثبات الهوية لتسهيل عملية التسليم. شكرًا لتفهمكم.</p>
			</div>
		</aside>
	</body>
</html>`;

export default printTemplate;
